import React, { useState, useContext } from "react";
import "../../stylesheet/forms.css";
import ContextApi from "../../context/ContextApi";
import InventorySearch from "./InventorySearch"
import ToastContext from "../../context/toasterContex"

const InventoryForm = ({ updateFormData }) => {
  const { formData } = useContext(ContextApi)
  const { toast } = useContext(ToastContext)
  const [toggleAlert, setToggleAlert] = useState(false);

  const handleAlert = () => {
    setToggleAlert(!toggleAlert);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    updateFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <div className="step_form">
      <div className="step_input">
        <label htmlFor="name">Inventory name</label>
        <input
          name="name"
          type="text"
          placeholder="Enter inventory name"
          onChange={handleInputChange}
        />
      </div>
      <div className="step_input">
        <label htmlFor="brand">Brand</label>
        <input
          name="brand"
          type="text"
          placeholder="Enter brand name"
          onChange={handleInputChange}
        />
      </div>

      <div className="step_input">
        <label htmlFor="category">Category</label>
        <select
          name="category"
          id="category"
          aria-label="Select Partner Type"
          onChange={handleInputChange}
        >
          <option disabled selected>
            Select category
          </option>
          <option value="Barbiturates">Barbiturates</option>
          <option value="Antibiotics">Antibiotics</option>
          <option value="Analgesics">Analgesics</option>
          <option value="Laxatives">Laxatives</option>
          <option value="Vitamins">Vitamins</option>
        </select>
      </div>

      <div className="step_doubles">
        <div className="step_inputs">
          <label htmlFor="unit_quantity">Base Unit Quantity</label>
          <input
            type="text"
            id="unit_quantity"
            placeholder="Enter Unit Quantity"
            inputMode="numeric"
            pattern="[0-9]*"
            name="unit_quantity"
            onChange={handleInputChange}
          />
        </div>

        <div className="step_inputs">
          <label htmlFor="measurement">Unit measurement</label>
          <select
            name="measurement"
            id="measurement"
            aria-label="Select unit measurement"
            onChange={handleInputChange}
          >
            <option value="" disabled selected>
              Select unit
            </option>
            <option value="ml">Ml</option>
            <option value="mg">Mg</option>
            <option value="teaspoon">Teaspoon</option>
            <option value="drop">Drop(s)</option>
            <option value="capsule">Capsule</option>
            <option value="suppository">Suppository</option>
            <option value="puff">Puff(s)</option>
          </select>
        </div>
      </div>
      <div className="step_doubles">
        <div className="step_inputs">
          <label htmlFor="quantity">Total Quantity Available</label>
          <input
            type="text"
            id="quantity"
            placeholder="Enter Total Available Quantity"
            inputMode="numeric"
            pattern="[0-9]*"
            name="quantity"
            onChange={handleInputChange}
          />
        </div>

        {/* <div className="step_inputs">
          <label htmlFor="measurement">Unit measurement</label>
          <select
            name="measurement"
            id="measurement"
            aria-label="Select unit"
            onChange={handleInputChange}
          >
            <option value="" disabled selected>
              Select unit
            </option>
            <option value="ml">Ml</option>
            <option value="mg">Mg</option>
            <option value="teaspoon">Teaspoon</option>
            <option value="drop">Drop(s)</option>
            <option value="capsule">Capsule</option>
            <option value="suppository">Suppository</option>
            <option value="puff">Puff(s)</option>
          </select>
        </div> */}
        <div className="step_input">
          <label htmlFor="price">Price</label>
          <div className="price_box">
            <span className="ml-3">
              ₦
            </span>
            <input
              onChange={handleInputChange}
              name="price"
              type="text"
              id="price"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>
        </div>
      </div>

      <div className="alert_box">
        <input
          type="checkbox"
          name="notification"
          id="notification"
          checked={toggleAlert}
          onClick={handleAlert}
        />
        <div className="flex items-center relative">
          <label
            htmlFor="notification"
            className="text-[#110C4A] text-sm font-semibold leading-none"
          >
            Set minimum inventory alert notification
          </label>
          <svg
            className="absolute right-[-8%] bottom-2"
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
          >
            <g clipPath="url(#clip0_1639_8766)">
              <path
                d="M9.50016 17.4163C13.8724 17.4163 17.4168 13.8719 17.4168 9.49967C17.4168 5.12742 13.8724 1.58301 9.50016 1.58301C5.12791 1.58301 1.5835 5.12742 1.5835 9.49967C1.5835 13.8719 5.12791 17.4163 9.50016 17.4163Z"
                stroke="#B1B1B4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 13.458H9.50792"
                stroke="#B1B1B4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.19629 7.12496C7.38241 6.59587 7.74978 6.14971 8.23334 5.86553C8.71689 5.58134 9.28541 5.47746 9.83822 5.57228C10.391 5.6671 10.8924 5.9545 11.2536 6.38359C11.6148 6.81268 11.8125 7.35575 11.8117 7.91663C11.8117 9.49996 9.43671 10.2916 9.43671 10.2916"
                stroke="#B1B1B4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1639_8766">
                <rect width="19" height="19" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

      {toggleAlert && (
        <div className="step_input mt-3">
          <label htmlFor="alert">Alert quantity limit</label>
          <input
            onChange={handleInputChange}
            name="alert"
            type="text"
            id="alert"
            placeholder="Enter quantity"
            inputMode="numeric"
            pattern="[0-9]*"
          />
        </div>
      )}


    </div>
  );
};

export default InventoryForm;
